import React from 'react';
import styled from '@emotion/styled';
import { RichText } from 'prismic-reactjs';
import { Box } from '@chakra-ui/core';

export const BoxWithWebCSS = styled(Box)`
	/*
		This can be used as a base index.css 

	  */
	/* 
	background: white;
	color: ${theme.colors.gray['900']}; 
	*/
	h1 {font-size: 4rem;}
    h2 {font-size: 3rem;}
    h3 {font-size: 2.25rem;}
    h4 {font-size: 1.875rem;}
    h5 {font-size: 1.25rem;}
	h1, h2, h3, h4, h5 {margin-bottom: 1rem;}
	p {margin-bottom: 1rem}
	img {border-radius: 6px;}
`;

interface Props {}

export const StyledRichText = (props) => {
	return (
		<BoxWithWebCSS>
			<RichText {...props} />
		</BoxWithWebCSS>
	);
};
